import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import Button, { ButtonProps } from '@material-ui/core/Button';
import IconButton, { IconButtonProps } from '@material-ui/core/IconButton';
import { Palette } from '@material-ui/core/styles/createPalette';
import Skeleton from '@material-ui/lab/Skeleton';

import { WithMyTheme } from '@keaze/web/theme';

interface FavoriteProps extends WithMyTheme {
  $favorite: boolean;
}

const favoriteIconStyles = (palette: Palette) => `
  svg {
    stroke: ${palette.secondary.main};
    fill: ${palette.secondary.main}; 
  }
`;

export const StyledActions = styled(Box)`
  display: flex;
`;

export const FavoriteButton = styled(Button)<ButtonProps & FavoriteProps>`
  ${({ theme: { palette, colors, breakpoints }, $favorite }) => `
    font-weight: 500;
    background-color: ${colors.greys.greys3}; 
     display: none;

    svg {
      stroke: ${palette.primary.main};
    }

    ${$favorite ? favoriteIconStyles(palette) : ''};

    ${breakpoints.up('md')} {
      display: flex;
    }
  `}
`;

export const FavoriteIconButton = styled(IconButton)<
  IconButtonProps & FavoriteProps
>`
  ${({ theme: { palette, colors, breakpoints }, $favorite }) => `
    border-radius: 0;
    background-color: ${colors.greys.greys23}; 
    margin-left: 2px;

    svg {
      stroke: ${palette.primary.main};
    }

    &:hover {
      background-color: ${colors.greys.greys23}; 
    }

    ${$favorite ? favoriteIconStyles(palette) : ''};

    ${breakpoints.up('md')} {
      &.MuiIconButton-root {
        display: none;
      }
    }
  `}
`;

export const StyledSkeleton = styled(Skeleton)`
  margin-left: 2px;
`;
